import * as React from 'react';
import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { Col, Row, Button } from 'reactstrap';
import AlertModal from '../../../../shared/components/Modal';
import Checkbox from '@material-ui/core/Checkbox';
import { withStyles } from '@material-ui/core/styles';
import { useHistory } from "react-router-dom";
import ApiClinicalStudio from '../../api/clinical_studio_api';

const MedicalCheckbox = withStyles({
    root: {
        '&$checked': {
            color: '#4ce1b6',
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

const UpdateModalRequirementsStudio = ({ closeModal,requirement, action, opened,id_estudio,id_tercero }) => {
    const history = useHistory();
    //Atributos
    const [number, setNumber] = React.useState(requirement.numero);
    const [stateRequirement, setStateRequirement] = React.useState(requirement.estado);
    const [description, setDescription] = React.useState(requirement.descripcion);

    //Modal
    const [openModal, setOpenModal] = React.useState(opened);
    const alertModal = (success, message) => {
        if (success == true) {
            setAlertColorModal("success");
        }
        else {
            setAlertColorModal("danger");
        }
        setAlerShowModal(true);
        setAlertMessageModal(message);
    }
    //Alerta
    const [showAlertModal, setAlerShowModal] = React.useState(false);
    const [messagAlerteModal, setAlertMessageModal] = React.useState(null);
    const [colorAlertModal, setAlertColorModal] = React.useState("success");

    const saveRequirement = () => {
        updateRequirement();
    }

    const updateRequirement = async () => {

        let dataReq = new FormData();
        dataReq.append("id_estudio",id_estudio);
        dataReq.append("id_tercero",id_tercero);
        dataReq.append("estado",stateRequirement);
        dataReq.append("numero",number);
        dataReq.append("descripcion",description);
        dataReq.append("id_requerimiento",requirement.id_requerimiento);

        fetch(`${process.env.REACT_APP_PUBLIC_URL}requerimientos/update`, {
            method: 'PUT',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body:dataReq
        }).then(response => 
            {
                if(response.status != 500 && response.status != 403)
                {
                    response.json()
                }
                else
                {
                    throw new Error(``);
                }
            }
            ).then(data => {

            refreshRequirements();
        }).catch(error => 
            alertModal(false,"Ha ocurrido un error el servidor")
        );
    }

    const refreshRequirements = async () => {
        try
        {
            await ApiClinicalStudio.checkStatusClinicalStudio(requirement.feasibility.id_estudio);
        }
        catch (e)
        {
            console.log("Error actualizando el estado del estudio")
        }
        let _url = "/clinical-studio/requirements";
        if (window.location.pathname === process.env.PUBLIC_URL + _url) {
            history.replace(process.env.PUBLIC_URL+"/");
            setTimeout(() => {
                history.push({
                    pathname: process.env.PUBLIC_URL +_url,
                    state: requirement.feasibility
                });
            }, 0);
        } else {

        }
    }

    React.useEffect(() => {

    }, []);

    return (
        <div>
            <Modal
                open={opened}
                onClose={e => {
                    setOpenModal(false);
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
            >
                <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>

                    <div>
                        <div className="card__title">
                            <h5 className="bold-text">Actualizar Requerimiento</h5>
                        </div>

                        <Row>
                            <Col md={6}>
                                <TextField
                                    onChange={(e) => {
                                        setNumber(e.target.value);
                                    }}
                                    style={{ minWidth: '300px', maxWidth: '100%' }}
                                    id="input-with-icon-grid"
                                    value={number}
                                    type='number'
                                    label="Número de Requerimiento"
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        style: { color: '#646777' }
                                    }}
                                />
                            </Col>
                            <Col md={6}>
                                <TextField
                                    id="standard-select-estado"
                                    select
                                    label=" "
                                    helperText="Estado Actual"
                                    value={stateRequirement}
                                    onChange={(event) => {
                                        setStateRequirement(event.target.value);
                                    }}
                                    style={{ minWidth: '300px', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        style: { color: '#646777' }
                                    }}
                                >
                                    <MenuItem key={0} value={true}>
                                        Aprobado
                                    </MenuItem>
                                    <MenuItem key={1} value={false}>
                                        No Aprobado
                                    </MenuItem>
                                </TextField>
                            </Col>
                            <Col md={12}>
                                <TextField
                                    onChange={(e) => {
                                        setDescription(e.target.value);
                                    }}
                                    style={{ minWidth: '300px', maxWidth: '100%' }}
                                    id="input-with-icon-grid"
                                    value={description}
                                    label="Descripcion"
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        style: { color: '#646777' }
                                    }}
                                />
                            </Col>
                        </Row>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            disabled={false}
                            style={{ marginTop: 10, marginRight: 10 }}
                            variant="contained"
                            className="btn btn-primary btn-sm text-white"
                            onClick={() => {
                                saveRequirement();
                            }}
                        >
                            Actualizar
                        </Button>
                        <Button
                            style={{ marginTop: 10 }}
                            variant="contained"
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                                closeModal(false);
                            }}
                        >
                            Cerrar
                        </Button>
                    </div>
                </div>
            </Modal>

            <AlertModal
                color={colorAlertModal}
                title={messagAlerteModal}
                modal={showAlertModal}
                onOk={() => setAlerShowModal(false)}
                toggle={() => setAlerShowModal(false)}
            />
        </div>
    );
};
export default UpdateModalRequirementsStudio;
